/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApplyIdComponent } from './apply-id.component';
import { SysqueFrameModule } from '../../../../../../../shared/ui/src/lib/components/sysque-frame';
import { DxButtonModule } from 'devextreme-angular';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [
  { path: 'dialog/apply-conduit-id', component: ApplyIdComponent, data: { isConduitIdDialog: true } },
  { path: 'apply-equipment-device-id', component: ApplyIdComponent, data: { isConduitIdDialog: false } },
];

@NgModule({
  declarations: [ApplyIdComponent],
  imports: [
    CommonModule,
    FormsModule,
    SysqueFrameModule,
    AlertModule,
    DxButtonModule,
    RouterModule.forChild(routes),
  ],
  exports: [ApplyIdComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApplyIdModule {}
